module.exports = __webpack_public_path__ + "img/wins.47ea7640.png";